import { collectTrackData } from '@/utils/Tracker/tracker';
import { collect } from '@/analytics';

const EVENT = {
  NAME: 'gaEvent',
  CATEGORY: {
    HOME: 'Nova Home',
    STUDIO: 'HostGator Studio',
    AI_SITE_CREATOR: 'Criador de Site com IA',
  },
  ACTION: {
    GREETING_BANNER: {
      CLICK_BUTTON: 'Clique no Botão - Criar Site',
    },
    HIGHLIGHT_PRODUCTS: {
      CREATE_SITE: {
        CLICK_BUTTON: 'Clique no Botão - Começar',
      },
      EMAIL_PRO: {
        CLICK_BUTTON: 'Clique no Botão - Conhecer Agora',
      },
      STUDIO_FREE: {
        CLICK_BUTTON: 'Clique no Botão - Ir para o Studio',
      },
      STUDIO_PRO: {
        CLICK_BUTTON: 'Clique no Botão - Ir para o Studio',
      },
      STUDIO_TRIAL: {
        CLICK_BUTTON: 'Clique no Botão - Ir para o Studio',
      },
      STUDIO_HIRE_TRIAL: {
        CLICK_BUTTON: 'Clique no Botão - Começar agora',
      },
      VPS_N8N: {
        CLICK_BUTTON: 'Clique no Botão - Conhecer VPS n8n',
      },
      VPS_OPEN_CLAW: {
        CLICK_BUTTON: 'Clique no Botão - Conhecer VPS OpenClaw',
      },
    },
    CONTRACTED_PRODUCTS: {
      HOSTINGS: {
        CLICK_MANAGE_HOSTING: 'Clique no Botão - Gerenciar',
        CLICK_GO_TO_HOSTINGS: 'Clique no Botão - Ir para Hospedagens',
        CLICK_HIRE_HOSTING: 'Clique no Botão - Contratar Hospedagem',
      },
      DOMAINS: {
        CLICK_MANAGE_DOMAIN: 'Clique no Botão - Gerenciar',
        CLICK_GO_TO_DOMAINS: 'Clique no Botão - Ir para Domínios',
        CLICK_HIRE_DOMAIN: 'Clique no Botão - Contratar Domínio',
      },
    },
    ADVERTISEMENTS: {
      CLICK_BUTTON: 'Clique no Botão - Aproveitar agora',
    },
    RESOURCES: {
      CARD_FREE_COURSES: {
        CLICK_BUTTON: 'Clique no Botão - Cursos gratuítos',
      },
      CARD_BLOG: {
        CLICK_BUTTON: 'Clique no Botão - HostGator Blog',
      },
      CARD_LIVES: {
        CLICK_BUTTON: 'Clique no Botão - Lives do Youtube',
      },
      CARD_HELP_CENTER: {
        CLICK_BUTTON: 'Clique no Botão - Central de Ajuda',
      },
    },
    AI_SITE_CREATOR: {
      WORDPRESS_BANNER_CLICK: 'Clique no Botão - Começar agora',
      CREATOR_BANNER_CLICK: 'Clique no Botão - Quero meu site',
    },
    DIRECT_ACCESS_URL: 'Acesso Direto por URL',
  },
  LABEL: {
    GREETING_BANNER: 'Banner de Saudações',
    HIGHLIGHT_PRODUCTS: {
      CREATE_SITE: 'Produtos em Destaque - Criar Site',
      EMAIL_PRO: 'Produtos em Destaque - Email Profissional',
      STUDIO_FREE: 'Nova Home - Banner Plano Grátis',
      STUDIO_PRO: 'Nova Home - Banner acessar Plano Pro',
      STUDIO_TRIAL: 'Nova Home - Banner acessar Plano Pro Trial',
      STUDIO_HIRE_TRIAL: 'Nova Home - Banner contratar Plano Pro Trial',
      VPS_N8N: 'Produtos em Destaque - Card VPS n8n',
      VPS_OPEN_CLAW: 'Produtos em Destaque - Card VPS OpenClaw',
    },
    CONTRACTED_PRODUCTS: {
      HOSTINGS: 'Produtos Contratados - Hospedagens',
      DOMAINS: 'Produtos Contratados - Domínios',
    },
    ADVERTISEMENTS: 'Anúncios',
    RESOURCES: 'Recursos',
    AI_SITE_CREATOR: {
      WORDPRESS_BANNER: 'Nova Home - Banner WordPress com IA',
      CREATOR_BANNER: 'Nova Home - Banner Criador de Sites com IA',
    },
    DIRECT_ACCESS: {
      CREATE_SITE: 'Aba Criar Site',
      EMAIL_PRO: 'Aba E-mail Profissional',
      STUDIO: 'Aba HostGator Studio',
      VPS_N8N: 'Aba VPS n8n',
      VPS_OPEN_CLAW: 'Aba VPS OpenClaw',
    },
  },
};

const events = {
  greetingBannerClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.GREETING_BANNER.CLICK_BUTTON,
    label: EVENT.LABEL.GREETING_BANNER,
  },
  highlightCreateSiteClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.HIGHLIGHT_PRODUCTS.CREATE_SITE.CLICK_BUTTON,
    label: EVENT.LABEL.HIGHLIGHT_PRODUCTS.CREATE_SITE,
  },
  highlightEmailProClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.HIGHLIGHT_PRODUCTS.EMAIL_PRO.CLICK_BUTTON,
    label: EVENT.LABEL.HIGHLIGHT_PRODUCTS.EMAIL_PRO,
  },
  highlightVpsN8nClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.HIGHLIGHT_PRODUCTS.VPS_N8N.CLICK_BUTTON,
    label: EVENT.LABEL.HIGHLIGHT_PRODUCTS.VPS_N8N,
  },
  highlightVpsOpenClawClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.HIGHLIGHT_PRODUCTS.VPS_OPEN_CLAW.CLICK_BUTTON,
    label: EVENT.LABEL.HIGHLIGHT_PRODUCTS.VPS_OPEN_CLAW,
  },
  highlightStudioFreeClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.HIGHLIGHT_PRODUCTS.STUDIO_FREE.CLICK_BUTTON,
    label: EVENT.LABEL.HIGHLIGHT_PRODUCTS.STUDIO_FREE,
  },
  highlightStudioProClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.HIGHLIGHT_PRODUCTS.STUDIO_PRO.CLICK_BUTTON,
    label: EVENT.LABEL.HIGHLIGHT_PRODUCTS.STUDIO_PRO,
  },
  highlightStudioTrialClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.HIGHLIGHT_PRODUCTS.STUDIO_TRIAL.CLICK_BUTTON,
    label: EVENT.LABEL.HIGHLIGHT_PRODUCTS.STUDIO_TRIAL,
  },
  highlightStudioHireTrialClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.HIGHLIGHT_PRODUCTS.STUDIO_HIRE_TRIAL.CLICK_BUTTON,
    label: EVENT.LABEL.HIGHLIGHT_PRODUCTS.STUDIO_HIRE_TRIAL,
  },
  contractedHostingsManageClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.CONTRACTED_PRODUCTS.HOSTINGS.CLICK_MANAGE_HOSTING,
    label: EVENT.LABEL.CONTRACTED_PRODUCTS.HOSTINGS,
  },
  contractedHostingsGoToClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.CONTRACTED_PRODUCTS.HOSTINGS.CLICK_GO_TO_HOSTINGS,
    label: EVENT.LABEL.CONTRACTED_PRODUCTS.HOSTINGS,
  },
  contractedHostingsHireClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.CONTRACTED_PRODUCTS.HOSTINGS.CLICK_HIRE_HOSTING,
    label: EVENT.LABEL.CONTRACTED_PRODUCTS.HOSTINGS,
  },
  contractedDomainsManageClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.CONTRACTED_PRODUCTS.DOMAINS.CLICK_MANAGE_DOMAIN,
    label: EVENT.LABEL.CONTRACTED_PRODUCTS.DOMAINS,
  },
  contractedDomainsGoToClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.CONTRACTED_PRODUCTS.DOMAINS.CLICK_GO_TO_DOMAINS,
    label: EVENT.LABEL.CONTRACTED_PRODUCTS.DOMAINS,
  },
  contractedDomainsHireClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.CONTRACTED_PRODUCTS.DOMAINS.CLICK_HIRE_DOMAIN,
    label: EVENT.LABEL.CONTRACTED_PRODUCTS.DOMAINS,
  },
  advertisementsClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.ADVERTISEMENTS.CLICK_BUTTON,
    label: EVENT.LABEL.ADVERTISEMENTS,
  },
  resourcesFreeCoursesClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.RESOURCES.CARD_FREE_COURSES.CLICK_BUTTON,
    label: EVENT.LABEL.RESOURCES,
  },
  resourcesBlogClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.RESOURCES.CARD_BLOG.CLICK_BUTTON,
    label: EVENT.LABEL.RESOURCES,
  },
  resourcesLivesClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.RESOURCES.CARD_LIVES.CLICK_BUTTON,
    label: EVENT.LABEL.RESOURCES,
  },
  resourcesHelpCenterClick: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.RESOURCES.CARD_HELP_CENTER.CLICK_BUTTON,
    label: EVENT.LABEL.RESOURCES,
  },
  highlightSiteCreatorWordpressBannerClick: {
    campaign: EVENT.CATEGORY.AI_SITE_CREATOR,
    action: EVENT.ACTION.AI_SITE_CREATOR.WORDPRESS_BANNER_CLICK,
    label: EVENT.LABEL.AI_SITE_CREATOR.WORDPRESS_BANNER,
  },
  highlightAiSiteCreatorCreatorClick: {
    campaign: EVENT.CATEGORY.AI_SITE_CREATOR,
    action: EVENT.ACTION.AI_SITE_CREATOR.CREATOR_BANNER_CLICK,
    label: EVENT.LABEL.AI_SITE_CREATOR.CREATOR_BANNER,
  },
  directAccessCreateSiteTab: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.DIRECT_ACCESS_URL,
    label: EVENT.LABEL.DIRECT_ACCESS.CREATE_SITE,
  },
  directAccessEmailProTab: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.DIRECT_ACCESS_URL,
    label: EVENT.LABEL.DIRECT_ACCESS.EMAIL_PRO,
  },
  directAccessStudioTab: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.DIRECT_ACCESS_URL,
    label: EVENT.LABEL.DIRECT_ACCESS.STUDIO,
  },
  directAccessVpsN8nTab: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.DIRECT_ACCESS_URL,
    label: EVENT.LABEL.DIRECT_ACCESS.VPS_N8N,
  },
  directAccessVpsOpenClawTab: {
    campaign: EVENT.CATEGORY.HOME,
    action: EVENT.ACTION.DIRECT_ACCESS_URL,
    label: EVENT.LABEL.DIRECT_ACCESS.VPS_OPEN_CLAW,
  },
};

const greetingBannerClick = () => {
  collect({
    event: 'gaEvent',
    ...events.greetingBannerClick,
  });
  collectTrackData(events.greetingBannerClick);
};
const highlightEmailProClick = () => {
  collect({
    event: 'gaEvent',
    ...events.highlightEmailProClick,
  });
  collectTrackData(events.highlightEmailProClick);
};

const highlightStudioFreeClick = () => {
  collect({
    event: 'gaEvent',
    ...events.highlightStudioFreeClick,
  });
  collectTrackData(events.highlightStudioFreeClick);
};

const highlightStudioProClick = () => {
  collect({
    event: 'gaEvent',
    ...events.highlightStudioProClick,
  });
  collectTrackData(events.highlightStudioProClick);
};

const highlightStudioHireTrialClick = () => {
  collect({
    event: 'gaEvent',
    ...events.highlightStudioHireTrialClick,
  });
  collectTrackData(events.highlightStudioHireTrialClick);
};

const highlightStudioTrialClick = () => {
  collect({
    event: 'gaEvent',
    ...events.highlightStudioTrialClick,
  });
  collectTrackData(events.highlightStudioTrialClick);
};

const highlightCreateSiteClick = () => {
  collect({
    event: 'gaEvent',
    ...events.highlightSiteCreatorWordpressBannerClick,
  });
  collectTrackData(events.highlightSiteCreatorWordpressBannerClick);
};

const highlightAiSiteCreatorCreatorClick = () => {
  collect({
    event: 'gaEvent',
    ...events.highlightAiSiteCreatorCreatorClick,
  });
  collectTrackData(events.highlightAiSiteCreatorCreatorClick);
};

const highlightVpsN8nClick = () => {
  collect({
    event: 'gaEvent',
    ...events.highlightVpsN8nClick,
  });
  collectTrackData(events.highlightVpsN8nClick);
};

const highlightVpsOpenClawClick = () => {
  collect({
    event: 'gaEvent',
    ...events.highlightVpsOpenClawClick,
  });
  collectTrackData(events.highlightVpsOpenClawClick);
};

const handleHighlightClick = (id) => {
  switch (id) {
    case 2:
      return highlightCreateSiteClick();
    case 3:
      return highlightEmailProClick();
    case 15:
      return highlightAiSiteCreatorCreatorClick();
    case 97:
      return highlightVpsOpenClawClick();
    case 99:
      return highlightVpsN8nClick();
    default:
      return '';
  }
};

const contractedHostingsManageClick = () => {
  collect({
    event: 'gaEvent',
    ...events.contractedHostingsManageClick,
  });
  collectTrackData(events.contractedHostingsManageClick);
};

const contractedHostingsGoToClick = () => {
  collect({
    event: 'gaEvent',
    ...events.contractedHostingsGoToClick,
  });
  collectTrackData(events.contractedHostingsGoToClick);
};

const contractedHostingsHireClick = () => {
  collect({
    event: 'gaEvent',
    ...events.contractedHostingsHireClick,
  });
  collectTrackData(events.contractedHostingsHireClick);
};

const contractedDomainsManageClick = () => {
  collect({
    event: 'gaEvent',
    ...events.contractedDomainsManageClick,
  });
  collectTrackData(events.contractedDomainsManageClick);
};

const contractedDomainsGoToClick = () => {
  collect({
    event: 'gaEvent',
    ...events.contractedDomainsGoToClick,
  });
  collectTrackData(events.contractedDomainsGoToClick);
};

const contractedDomainsHireClick = () => {
  collect({
    event: 'gaEvent',
    ...events.contractedDomainsHireClick,
  });
  collectTrackData(events.contractedDomainsHireClick);
};

const advertisementsClick = () => {
  collect({
    event: 'gaEvent',
    ...events.advertisementsClick,
  });
  collectTrackData(events.advertisementsClick);
};

const resourcesFreeCoursesClick = () => {
  collect({
    event: 'gaEvent',
    ...events.resourcesFreeCoursesClick,
  });
  collectTrackData(events.resourcesFreeCoursesClick);
};

const resourcesBlogClick = () => {
  collect({
    event: 'gaEvent',
    ...events.resourcesBlogClick,
  });
  collectTrackData(events.resourcesBlogClick);
};

const resourcesLivesClick = () => {
  collect({
    event: 'gaEvent',
    ...events.resourcesLivesClick,
  });
  collectTrackData(events.resourcesLivesClick);
};

const resourcesHelpCenterClick = () => {
  collect({
    event: 'gaEvent',
    ...events.resourcesHelpCenterClick,
  });
  collectTrackData(events.resourcesHelpCenterClick);
};

const handleResourcesClick = (id) => {
  switch (id) {
    case 8:
      return resourcesFreeCoursesClick();
    case 9:
      return resourcesBlogClick();
    case 10:
      return resourcesLivesClick();
    case 11:
      return resourcesHelpCenterClick();
    default:
      return '';
  }
};

const directAccessCreateSiteTab = () => {
  collect({ event: 'gaEvent', ...events.directAccessCreateSiteTab });
  collectTrackData(events.directAccessCreateSiteTab);
};

const directAccessEmailProTab = () => {
  collect({ event: 'gaEvent', ...events.directAccessEmailProTab });
  collectTrackData(events.directAccessEmailProTab);
};

const directAccessStudioTab = () => {
  collect({ event: 'gaEvent', ...events.directAccessStudioTab });
  collectTrackData(events.directAccessStudioTab);
};

const directAccessVpsN8nTab = () => {
  collect({ event: 'gaEvent', ...events.directAccessVpsN8nTab });
  collectTrackData(events.directAccessVpsN8nTab);
};

const directAccessVpsOpenClawTab = () => {
  collect({ event: 'gaEvent', ...events.directAccessVpsOpenClawTab });
  collectTrackData(events.directAccessVpsOpenClawTab);
};

const analytics = {
  greetingBannerClick,
  highlightCreateSiteClick,
  highlightEmailProClick,
  highlightStudioFreeClick,
  highlightStudioProClick,
  highlightStudioHireTrialClick,
  highlightStudioTrialClick,
  handleHighlightClick,
  contractedHostingsManageClick,
  contractedHostingsGoToClick,
  contractedHostingsHireClick,
  contractedDomainsManageClick,
  contractedDomainsGoToClick,
  contractedDomainsHireClick,
  advertisementsClick,
  resourcesFreeCoursesClick,
  resourcesBlogClick,
  resourcesLivesClick,
  resourcesHelpCenterClick,
  handleResourcesClick,
  highlightAiSiteCreatorCreatorClick,
  directAccessCreateSiteTab,
  directAccessEmailProTab,
  directAccessStudioTab,
  directAccessVpsN8nTab,
  directAccessVpsOpenClawTab,
};

export default analytics;
